import React from 'react';
import {
  ShopCategories,
  ShopPagination,
  ProductListItem,
} from '.';
import {
  Wrapper,
  Shape,
} from '../common';
import './ProductList.scss';

const ProductList = (props) => {
  const {
    products,
    categories,
    siteMetadata,
    location,
    pageContext,
    pathPrefix,
  } = props;
  const { shopSlug } = siteMetadata;
  return (
    <section className="product-list">
      <div className="framing-shapes">
        <Shape
          shapeName="muncher"
          shapeColour="#EEEA00"
        />
        <Shape
          shapeName="pebbles"
          shapeColour="#F68E00"
        />
        <Shape
          shapeName="rainbow"
          shapeColour="#00BC74"
        />
        <Shape
          shapeName="moon"
          shapeColour="#FF6AB8"
        />
      </div>
      <Wrapper isBound>
        <div className="grid-container">
          {categories && (
            <ShopCategories
              categories={categories}
              location={location}
              siteMetadata={siteMetadata}
            />
          )}
          <div className="products">
            {products.map(product => (
              <ProductListItem
                key={product.handle}
                shopSlug={shopSlug}
                {...product}
              />
            ))}
          </div>
        </div>
      </Wrapper>
      <Wrapper isBound>
        <ShopPagination
          pageContext={pageContext}
          pathPrefix={pathPrefix}
        />
      </Wrapper>
    </section>
  );
};

export default ProductList;
